import styled from "styled-components";
import { Card, Chip, Box, Paper } from "@mui/material";
import { THEME_MAP } from "../../theme";

export const Container = styled.div`
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
`;

export const StyledCard = styled(Card)`
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
`;

export const StatusChip = styled(Chip)`
  margin: 4px;
`;

export const ResultContainer = styled(Box)`
  margin-top: 16px;
  padding: 16px;
  background-color: ${THEME_MAP["color-basic-100"]};
  border-radius: 8px;
  max-height: 400px;
  overflow-y: auto;
`;

export const EstablishmentCard = styled(Paper)`
  padding: 12px;
  margin: 8px 0;
  border-left: 4px solid ${THEME_MAP["color-primary-500"]};
`;
